import React from "react";
import {
  SideLinesLayer,
  LeftLine,
  RightLine,
  EmailLink,
  Link,
} from "./SideLines.Styled";
import { FiGithub, FiInstagram, FiLinkedin } from "react-icons/fi";
import { motion } from "framer-motion";
import { commonOpacityAppearVariants } from "../../animations/motion";

const SideLines = () => {
  return (
    <SideLinesLayer
      as={motion.div}
      variants={commonOpacityAppearVariants}
      initial="closed"
      animate="open"
      transition={{ delay: 0.75, duration: 0.6 }}
    >
      <LeftLine>
        <Link
          href="https://github.com/VietHoang37"
          rel="noopener noreferrer"
          target="_blank"
          aria-label="GitHub"
        >
          <FiGithub aria-hidden="true" />
        </Link>
        <Link
          href="https://instagram.com/viet_hoang_ng"
          rel="noopener noreferrer"
          target="_blank"
          aria-label="Instagram"
        >
          <FiInstagram aria-hidden="true" />
        </Link>
        <Link
          href="https://www.linkedin.com/in/viet-hoang-nguyen-591212226/"
          rel="noopener noreferrer"
          target="_blank"
          aria-label="LinkedIn"
        >
          <FiLinkedin aria-hidden="true" />
        </Link>
      </LeftLine>
      <RightLine>
        <EmailLink href="mailto:viethoang.ng7@gmail.com">
          viethoang.ng7@gmail.com
        </EmailLink>
      </RightLine>
    </SideLinesLayer>
  );
};

export default SideLines;
